import { render, staticRenderFns } from "./ProgramModal.vue?vue&type=template&id=64cdafa0&"
import script from "./ProgramModal.vue?vue&type=script&lang=js&"
export * from "./ProgramModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports